import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query NarrativesCommunityGetCompanyByCanonical($canonicalUrl: String!) {
    Company(canonicalURL: $canonicalUrl) {
      id
      name
      uniqueSymbol
      tickerSymbol
      media {
        url
        transform
      }
      info {
        url
      }
      narrativeCount
      primaryNarrativeCount
      commentCount
    }
  }
`);

export const useNarrativeCommunityCompany = makeGqlQuery(QUERY);
